import * as React from 'react';

interface NotificationAddProps {
  className?: string;
  title?: string;
}

export function NotificationAdd({ className, title }: NotificationAddProps) {
  return (
    <svg
      className={className}
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-label={title}
    >
      {title && <title>{title}</title>}
      <path
        d="M10.5 22C9.95 22 9.47917 21.8042 9.0875 21.4125C8.69583 21.0208 8.5 20.55 8.5 20H12.5C12.5 20.55 12.3042 21.0208 11.9125 21.4125C11.5208 21.8042 11.05 22 10.5 22ZM16.5 13V10H13.5V8H16.5V5H18.5V8H21.5V10H18.5V13H16.5ZM2.5 19V17H4.5V10C4.5 8.61667 4.91667 7.3875 5.75 6.3125C6.58333 5.2375 7.66667 4.53333 9 4.2V3.5C9 3.08333 9.14583 2.72917 9.4375 2.4375C9.72917 2.14583 10.0833 2 10.5 2C10.9167 2 11.2708 2.14583 11.5625 2.4375C11.8542 2.72917 12 3.08333 12 3.5V4.2C12.2333 4.26667 12.4625 4.3375 12.6875 4.4125C12.9125 4.4875 13.125 4.58333 13.325 4.7C13.075 4.93333 12.85 5.1875 12.65 5.4625C12.45 5.7375 12.275 6.03333 12.125 6.35C11.875 6.23333 11.6125 6.14583 11.3375 6.0875C11.0625 6.02917 10.7833 6 10.5 6C9.4 6 8.45833 6.39167 7.675 7.175C6.89167 7.95833 6.5 8.9 6.5 10V17H14.5V14.2C14.8 14.3833 15.1167 14.5333 15.45 14.65C15.7833 14.7667 16.1333 14.8583 16.5 14.925V17H18.5V19H2.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
